export default function MoveFolderIcon() {
  return (
    <svg viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.072 6.195h-8.9L8.254 3.268a.167.167 0 0 0-.038-.018h-6.23c-.344 0-.612.286-.612.65v15.212c0 .352.273.638.611.638h18.086c.331 0 .605-.288.612-.642V6.832a.625.625 0 0 0-.612-.638v.001zM2.787 4.745H7.67l1.446 1.45h-6.33v-1.45zm16.485 13.521H2.787V7.689h16.485v10.58-.002zM7.4 13.582v-1.079c0-.084.07-.154.155-.154h4.425v-1.464c0-.13.15-.201.25-.12l2.731 2.156a.14.14 0 0 1 .043.054.153.153 0 0 1 0 .136.16.16 0 0 1-.043.054l-2.731 2.156a.154.154 0 0 1-.25-.12v-1.464H7.554a.156.156 0 0 1-.155-.155z" fill="#333"/>
    </svg>
  );
}
